import React from 'react';
import { I18n, Trans } from 'react-i18next';

export class Server extends React.Component {
  render() {
  	
    return (
    	<I18n ns="translations">
        {
          (t, { i18n }) => (
		   <section id="prop-server-section">
		    <div className="container">
		      <div className="row">
		        <div className="col-md-4 col-xs-12 prop_server_img">
		          <img src="images/prop_server_img.png"/>
		        </div>
		        <div className="col-md-8 col-xs-12">
		          <div className="content-part">
		            <h3>{t('servetitle')}</h3>
		            <p>{t('servepara1')} <b className="bold">{t('servebold1')} </b>{t('servepara2')} </p>
		            <p>{t('servepara3')}<b className="bold">{t('servebold2')}</b> {t('servepara4')}</p>
		            <p>{t('servepara5')} <b className="bold"> {t('servebold5')} </b> {t('servepara6')} <i>{t('serveitalic')} </i> {t('servepara7')}</p>
		          </div>
		        </div>
		      </div>
		    </div>
		  </section>
		  )
        }
      </I18n>
	   )
    }
}
		  


// WEBPACK FOOTER //
// ./src/components/Propos/Server/Server.js